<template>
  <div>
    <PageTitle
      v-if="Expense.status == 'Not Paid'"
      title="Expense Details"
      :backBtn="true"
      :changeStatus="true"
      @onClickChangeStatus="onClickChangeStatus"
    />
    <PageTitle v-else title="Expense View" :backBtn="true" />

    <v-container
      fluid
      class="lighten-12 container"
      style="background-color: white"
    >
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12" class="py-1 px-5">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title saletiltle"
              ><v-icon color="blue" small>mdi-sale</v-icon
              ><span class="ml-3">Expense Details</span></v-card-title
            >
            <v-container fluid class="container saledetailscard">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                  <v-row class="pt-0 mb-5">
                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="reference_number"
                    >
                      <v-icon>mdi-sale</v-icon>
                      {{
                        Expense.reference_number
                          ? Expense.reference_number
                          : '----'
                      }}
                    </v-col>

                    <v-col cols="12" sm="12" md="2" lg="2" class="text-right">
                      <span class="statustext pr-5">Status</span>
                      <v-chip
                        label
                        text-color="white"
                        :color="getExpenseOrderStatusColor(Expense.status)"
                        dark
                        class="orderData"
                      >
                        {{ Expense.status ? Expense.status : '----' }}
                      </v-chip>
                    </v-col>

                    <v-col cols="12" sm="12" md="3" lg="3" class="text-right">
                      <span class="statustext pr-5">Total Amount</span>
                      <v-chip color="bule" class="pa-0 pulse" outlined>
                        Rs. {{ Expense.amount | formatCurrency }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2" class="text-right">
                      <span class="statustext pr-5">Paid Amount</span>
                      <v-chip color="green" class="pa-0 pulse" outlined>
                        Rs. {{ Expense.paid_amount | formatCurrency }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2" class="text-right">
                      <span class="statustext pr-5">Due Amount</span>
                      <v-chip color="red" class="pa-0 pulse" outlined>
                        Rs.
                        {{
                          (Expense.amount - Expense.paid_amount)
                            | formatCurrency
                        }}
                      </v-chip>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Expense Date </v-row>
                      <v-row>
                        <v-icon small class="mr-1">mdi-calendar</v-icon>
                        {{ Expense.date | formatDate }}
                      </v-row>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Expense for </v-row>
                      <v-row>
                        {{ Expense.expense_for }}
                      </v-row>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="shoptext pr-5 pt-0"
                      v-if="Expense.shop != null"
                    >
                      <v-row class="subtextlable"> Shop </v-row>
                      <v-row>
                        {{ Expense.shop ? Expense.shop.name : '' }}
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="3"
                      lg="3"
                      class="shoptext pr-5 pt-0"
                      v-else
                    >
                      <v-row class="subtextlable"> WareHouse </v-row>
                      <v-row>
                        {{ Expense.warehouse ? Expense.warehouse.name : '' }}
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="shoptext pr-0 pt-0"
                    >
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Category </v-row>
                      <v-row>
                        {{ Expense.category ? Expense.category.name : '' }}
                      </v-row>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Remark </v-row>
                      <v-row>
                        {{ Expense.remark ? Expense.remark : '----' }}
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <change-status
        :visible="visibleChangeStatusModal"
        :statuses="expenseStatuses"
        :statusNote="Expense.status_note"
        :selectedStatus="Expense.status"
        @onChangeStatus="onChangeStatus"
        @close="onCloseChangeStatus"
      ></change-status>
    </v-container>
  </div>
</template>

<script>
import ChangeStatus from '@/components/shared/ChangeStatus';
import FileUpload from '@/components/base/FileUpload';
import 'jspdf-autotable';
import VueDocPreview from 'vue-doc-preview';
import confirmation from '@/modules/shared/components/confirmation';
import _ from 'lodash';
import axios from '@/plugins/axios';
import required from 'vuelidate/lib/validators';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';

export default {
  data: () => ({
    Expense: [],
    visibleChangeStatusModal: false,
    expenseStatuses: [
      { requiredNote: false, status: 'Paid' },
      { requiredNote: false, status: 'Not Paid' },
      { requiredNote: true, status: 'Canceled' },
    ],
    expenseStatus: ['Paid', 'Canceled', 'Not Paid'],
    expenseId: '',
  }),
  methods: {
    onChangeStatus(value) {
      let id = this.$route.params.id;

      axios
        .patch(`expenses/${id}/change-status`, value)
        .then((res) => {
          this.GetExpense();
          this.visibleChangeStatusModal = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    onClickChangeStatus(value) {
      this.visibleChangeStatusModal = true;
    },
    onCloseChangeStatus() {
      this.visibleChangeStatusModal = false;
    },

    GetExpense() {
      let expenseId = this.$route.params.id;

      axios
        .get(`expenses/${expenseId}`)
        .then((res) => {
          this.Expense = res.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },

    changeStatus() {
      this.Expense.isUpdate = !this.Expense.isUpdate;
      if (!this.Expense.isUpdate) {
        this.UpdateStatus();
      }
    },

    getExpenseOrderStatusColor(status) {
      switch (status) {
        case 'Paid':
          return 'green';
          break;
        case 'Not Paid':
          return 'red';
          break;
        case 'Canceled':
          return 'red';
          break;
        case 'Partially Paid':
          return 'orange';
          break;
        default:
          break;
      }
    },
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    VueDocPreview,
    ChangeStatus,
  },
  created() {
    this.GetExpense();
  },
  computed: {},
};
</script>

<style scoped>
.orderData {
  font-weight: bold;
}
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
  padding: 0 !important;
  padding-left: 10px !important;
}
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.reference_number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.shoptext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.statustext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: center;

  color: #045894;
}
.pulse {
  background: #2c44cc;

  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(102, 15, 15, 0.4);
    box-shadow: 0 0 0 0 rgba(6, 173, 233, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 0 rgba(102, 15, 15, 0.4);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(102, 15, 15, 0.4);
    box-shadow: 0 0 0 0 rgba(179, 52, 30, 0);
  }
}
</style>
